import React from "react";
import {
  Circle,
  GeoJSON,
  LayerGroup,
  MapContainer,
  Marker,
  TileLayer,
  useMap,
} from "react-leaflet";
import { styles }  from "../shared/mapStyles";

const MAPTILER_API_KEY = "ixOQiZGuZrAkWJk96yp1";

const VisitorPhotoMap = ({
  precision,
  location,
  countyGeoJSON,
  flightPathGeoJSON,
}) => {
  const hasLocation = precision === "verified" || precision === "placed";

  return (
    <MapContainer
      center={hasLocation ? location : null}
      zoom={hasLocation ? 16 : null}
      scrollWheelZoom={false}
      style={{ height: "100%", width: "100%" }}
    >
      <TileLayer
        url={`https://api.maptiler.com/maps/positron/256/{z}/{x}/{y}{r}.png?key=${MAPTILER_API_KEY}`}
      />
      {precision === "flight_path_interpolation" && (
        <LayerGroup>
          <GeoJSON
            data={flightPathGeoJSON}
            style={styles.flightPath}
            onEachFeature={(_feature, layer) => {
              const map = useMap();
              map.fitBounds(layer.getBounds());
            }}
          />
          <Circle
            center={location}
            radius={1609 / 2}
            {...styles.approximateArea}
          />
        </LayerGroup>
      )}
      {precision === "county" && (
        <GeoJSON
          data={countyGeoJSON}
          style={styles.county}
          onEachFeature={(_feature, layer) => {
            const map = useMap();
            map.fitBounds(layer.getBounds());
          }}
        />
      )}
      {hasLocation && <Marker position={location} />}
    </MapContainer>
  );
};

import renderer from "../shared/renderer";
renderer(VisitorPhotoMap);
